if (process.env.NODE_ENV === 'production') {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const { hostname, protocol, pathname, search, port } = window.location;

  if (isMobile && hostname.startsWith('www.')) {
    const newHostname = hostname.replace('www.', 'mobile.');
    const portString = port ? `:${port}` : '';
    window.location.href = `${protocol}//${newHostname}${portString}${pathname}${search}`;
  } else if (!isMobile && hostname.startsWith('mobile.')) {
    const newHostname = hostname.replace('mobile.', 'www.');
    const portString = port ? `:${port}` : '';
    window.location.href = `${protocol}//${newHostname}${portString}${pathname}${search}`;
  }
}

import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@vant/touch-emulator';
// 引入英文语言包
import enUS from 'vant/es/locale/lang/en-US';
import zhTW from 'vant/es/locale/lang/zh-TW';
import { getUser,getRemark } from './utils/auth'
import { Locale } from 'vant';
import { applyVantLocale } from './utils/vantLocale'
import { isQiabotNewType, openQiabotWidget } from './utils/qiabot'


// 设置vant组件库的语言
import { getDefaultLanguage } from './utils/common';
const currentLocale = localStorage.getItem('locale') || getDefaultLanguage();
applyVantLocale(currentLocale, Locale, enUS, zhTW)

import "ant-design-vue/lib/pagination/style/index.css";
import "ant-design-vue/lib/select/style/index.css";
import "ant-design-vue/lib/date-picker/style/index.css";
import { Pagination, Select, DatePicker,  ConfigProvider } from 'ant-design-vue';
Vue.use(Pagination).use(Select).use(DatePicker).use(ConfigProvider)

Vue.config.productionTip = false
Vue.config.ignoredElements = [/^altcha-/]

import './assets/css/common.less';
import './assets/fonts/iconfont.css';
import 'lib-flexible/flexible'

import i18n from './i18n/index'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Initialize device fingerprint collection
import deviceFingerprint from './utils/deviceFingerprint'
Vue.prototype.$deviceFingerprint = deviceFingerprint

// Initialize device fingerprint on app startup
deviceFingerprint.init().catch(error => {
  console.error('Failed to initialize device fingerprint:', error)
})

Vue.prototype.i18n = i18n

// 顶部title是否隐藏
Vue.prototype.hideTopBar = true

//货币单位
let localCurrency = localStorage.getItem('localCurrency') || 'USDT'
Vue.prototype.localCurrency = localCurrency


const ChatWoot = function () {
    console.log("ChatWoot")
    // let kefu = JSON.parse(window.localStorage.getItem('kefu_info'))
    // if (kefu === null) {
    //     return
    // }

    console.log("window.localStorage.username")
    let Remark = getRemark()
    let username = getUser()
    console.log(username)
    console.log(Remark)
    if(username !== null) {
        let obj = {
            name:"账号："+ username + " 备注：" + Remark, // Name of the user
            email: "", // Email of the user
            Remark: Remark, // Email of the user
            // identifier_hash: that.kfData.IdentifierHash // Identifier Hash generated in the previous step
        }
        // console.log(that.kfData.IdentifierHash)
        // if(js.identifierHash !== undefined) {
        //   obj.identifier_hash = js.identifierHash
        // }
        window.$chatwoot.setUser(username, obj);
    }

    window.$chatwoot.toggle('open');
}

const meiqia = function () {
    _MEIQIA('withoutBtn');
    _MEIQIA('showPanel');
    _MEIQIA('language','en')
    // 传递顾客信息
    _MEIQIA('metadata', {
        ID: getUser(), // 美洽默认字段
        name: getUser(), // 美洽默认字段
        username: getUser(), // 美洽默认字段
    });
    _MEIQIA('getPanelVisibility', function (visibility){
        console.log("customerList getPanelVisibility")
        if (visibility === 'visible') {
            // _MEIQIA('hidePanel');
        }
    });
}


// 定义一个全局函数
Vue.prototype.$kefu = function() {
    let Type = window.localStorage.getItem('kefuType')
    console.log(Type)
    if (isQiabotNewType(Type)) {
        openQiabotWidget()
        return
    }
    switch (Type) {
        case 'meiqia':
            meiqia()
            break
        case 'chatwoot':
            ChatWoot()
            break
    }
    // 在这里编写全局函数的逻辑
};

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
